var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.758 18.242a.304.304 0 0 1-.11.07l-4.187 1.672a.456.456 0 0 1-.125.016.384.384 0 0 1-.242-.094c-.088-.089-.115-.211-.078-.367l1.672-4.188a.304.304 0 0 1 .07-.109l8.03-8.03a.3.3 0 0 1 .424 0l2.576 2.576a.3.3 0 0 1 0 .424l-8.03 8.03zM19.703 5.867c.198.208.297.45.297.723 0 .273-.099.509-.297.707l-1.49 1.49a.3.3 0 0 1-.425 0l-2.576-2.575a.3.3 0 0 1 0-.424l1.491-1.491A.965.965 0 0 1 17.41 4c.274 0 .515.099.723.297l1.57 1.57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7117aa58a48a29ac526808a5c337e9b3.svg";
export { ForwardRef as ReactComponent };